/**
 * axiosの共通設定
 */
import axios from 'axios';

const baseURL = process.env.VUE_APP_WP_REST_API_URL;

export default axios.create({
  baseURL,
  responseType: 'json',
});
